<script setup>
import { computed } from 'vue';
import OnlyChangedDocsFilter from 'components/product-sheets/filters/OnlyChangedDocsFilter.vue';
import MultiFilter from './MultiFilter.vue';
import SelectFilter from './SelectFilter.vue';
import BoolFilter from './BoolFilter.vue';
import CheckboxFilter from './CheckboxFilter.vue';
import RangeFilter from './RangeFilter.vue';
import IndustryFilter from './IndustryFilter.vue';
import ColorFilter from './ColorFilter.vue';
import OnlyNewFilter from './OnlyNewFilter.vue';
import ActiveFilterTag from './ActiveFilterTag.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true
  },
  filterCode: {
    type: String,
    required: true
  }
});

const config = computed(() => {
  const childProps = {
    filterKey: props.config.param,
    label: props.config.label,
  };

  // Default to bool filter
  let child = BoolFilter;

  // Check if the config for a multi filter is given, update props
  if (props.config.type === 'multi') {
    childProps.options = props.config.options;
    child = MultiFilter;
  }

  if (props.config.type === 'select') {
    childProps.options = props.config.options;
    childProps.hideAllOption = props.config.hideAllOption;
    child = SelectFilter;
  }

  // Check for "boolean" type
  if (props.config.type === 'boolean') {
    childProps.value = props.config.selected;
  }

  // Check for "checkbox" type
  if (props.config.type === 'checkbox') {
    childProps.value = props.config.selected;
    childProps.disabled = props.config.disabled;
    child = CheckboxFilter;
  }

  // Check for "range" type
  if (props.config.type === 'range') {
    childProps.options = props.config.options;
    childProps.value = props.config.value;
    childProps.filterCode = props.filterCode;
    child = RangeFilter;
  }

  // Special component for the industry filter
  if (props.config.type === 'industry') {
    childProps.options = props.config.options;
    child = IndustryFilter;
  }

  if (props.config.type === 'color') {
    childProps.colors = props.config.options;
    child = ColorFilter;
  }

  // Special component for the "only changed docs" filter on the my sheets page
  if (props.config.type === 'onlyChangedDocs') {
    childProps.value = props.config.selected;
    child = OnlyChangedDocsFilter;
  }

  // Filter for "show only new" checkbox
  if (props.config.type === 'only_new') {
    childProps.minDate = props.config.minDate;
    childProps.disabled = props.config.disabled;
    childProps.legend = props.config.legend;
    child = OnlyNewFilter;
  }

  if (props.config.type === 'active_filter_tag') {
    child = ActiveFilterTag;
    childProps.value = props.config.value;
  }

  return {
    child,
    childProps,
  };
});

</script>

<template>
  <div>
    <component
      :is="config.child"
      v-bind="config.childProps" />
  </div>
</template>
